var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B9076623-62C9-4647-8842-0F9E8BBC13A9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1193.000000, -477.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "comp",
    transform: "translate(1193.000000, 477.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9,
    y: 1,
    width: 17,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 9,
    width: 8,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 20,
    y: 20,
    width: 4,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,5.5 L22,5.5",
    id: "Path-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,9.5 L22,9.5",
    id: "Path-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,14.5 L22.0140381,14.5",
    id: "Path-38"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCompany);
export default __webpack_public_path__ + "static/media/ico_company.1436325504a090d7a0fbb2d8fa206265.svg";
export { ForwardRef as ReactComponent };